// ────────────────────────────────────────────────────────────────
// subscription.js
//
// Single source of truth for deciding whether a user's subscription
// is actually active right now. The database only stores the *last
// assigned* `subscription_tier` and its `subscription_end`; nothing
// rewrites the tier when time passes, so reading it raw is stale
// for expired users. Everywhere the UI renders the tier it should
// go through `effectiveTier()` instead.
//
// Rules (match `isSubscriptionValid` in app/src/pages/LoginPage.jsx):
//   • no profile / no tier / tier === 'none' → 'none'
//   • tier === 'lifetime'                     → 'lifetime'
//   • otherwise, active only while
//     subscription_end > now(); else 'none'
// ────────────────────────────────────────────────────────────────

export function effectiveTier(profile) {
  if (!profile) return 'none';
  const tier = profile.subscription_tier;
  if (!tier || tier === 'none') return 'none';
  if (tier === 'lifetime') return 'lifetime';
  if (!profile.subscription_end) return 'none';
  return new Date(profile.subscription_end) > new Date() ? tier : 'none';
}

export function isSubscriptionActive(profile) {
  return effectiveTier(profile) !== 'none';
}
